import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { State } from "../../redux/store";
import { FaEdit } from "react-icons/fa";
import { MdRemoveCircle } from "react-icons/md";
import { PartnerInterface, ShowPartnersContext } from "./types";
import { useTranslation } from "react-i18next";
import { hostName } from "../../requestMethods";
import { useNavigate } from "react-router";

const DataPartners: React.FC = () => {
  const { partners } = useSelector((state: State) => state.partners);

  const {  
    showEditModal, 
    setShowEditModal,
    showDeleteModal, 
    setShowDeleteModal,
    setSelectedPartner,
  } = useContext(ShowPartnersContext)

  const toggleEditPartner = (partner: PartnerInterface) => { 
    setShowEditModal(!showEditModal)
    setSelectedPartner(partner)
  };

  const toggleDeletePartner = (partner: PartnerInterface) => {
    setShowDeleteModal(!showDeleteModal)
    setSelectedPartner(partner)
  };

  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="flex flex-col border mt-3">
    <div className="overflow-x-auto">
      <div className="inline-block min-w-full sm:px-6 lg:px-8">
        <div className="overflow-hidden">
          <table className="min-w-full text-center text-sm font-light border border-black">
            <thead className="border-b font-medium bg-main text-white border-black">
              <tr>
                <th className="px-4 py-4 border-r border-black">{t("Nom")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Photo")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Role")}</th>
                <th className="px-4 py-4 border-r border-black">{t("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {partners.map((partner: PartnerInterface, index) =>(
                <tr className="border-b bg-white border-black" key={index}>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium hover:bg-gray-200" onClick={() => navigate(`${partner._id}`)}>
                    {partner.name}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    <div className="flex justify-center">
                      {partner.image && 
                        <img className="rounded-full w-28 h-28" src={hostName + "imgs/partners/" + partner.image} alt="ss"/>
                      }
                    </div>
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    {partner.role}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 border-r border-black font-medium">
                    <div className="flex justify-center">
                      <FaEdit
                        className="text-second text-2xl"
                        onClick={() => toggleEditPartner(partner)}
                      />
                      <MdRemoveCircle
                        className="text-red text-2xl"
                        onClick={() => toggleDeletePartner(partner)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  );
    // <div className="grid sm:grid-cols-1 lg:grid-cols-3 gap-2 mt-4">
    //   {partners.map((partner: PartnerInterface, index) => (
    //     <div className={`${partner._id === AssId  ? "bg-main" : "" } bg-white px-6 py-4 rounded border shadow hover:bg-main`} 
    //     // style={{ backgroundColor: partner.color }}           
    //       key={index}>
    //       <div onClick={() => {
    //         setSelectedPartner(partner)
    //         navigate(`/partner/${partner._id}`)
    //       }}>
    //         <div>
    //           <img className="w-40 h-40" src={hostName + "imgs/partners/" + partner.image} alt="ss"/>
    //         </div>
    //         <span className="flex justify-between">
    //           {t("Societé")} : <b>{partner.name}</b>
    //         </span>
    //         <span className="flex justify-between">
    //           {t("description")} : <b>{partner.description}</b>
    //         </span>
    //       </div>
          // <div className="flex justify-center">
          //   <FaEdit
          //     className="text-blue"
          //     style={{
          //       fontSize: "22px",
          //     }}
          //     onClick={() => toggleEditPartner(partner)}
          //   />
          //   <MdRemoveCircle
          //     className="text-red"
          //     style={{
          //       fontSize: "22px",
          //     }}
          //     onClick={() => toggleDeletePartner(partner)}
          //   />
          // </div>
    //     </div>

    //   ))}
    // </div>
};

export default DataPartners;
